import React, { useEffect, useState } from 'react';
import { Box, Button, Paper, Typography, Stack } from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import PushNotificationSettings from './PushNotificationSettings';

const Event: React.FC = () => {
  const [entryTime, setEntryTime] = useState<Date | null>(null);
  const [endTime, setEndTime] = useState<Date | null>(null);
  const [eventEndTime, setEventEndTime] = useState<Date | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [now, setNow] = useState<Date>(new Date());

  useEffect(() => {
    fetch('/config/event-timer.json')
      .then(res => {
        if (!res.ok) throw new Error('設定ファイルの取得に失敗しました');
        return res.json();
      })
      .then(data => {
        setEntryTime(new Date(data.entryTime));
        setEndTime(new Date(data.endTime));
        setEventEndTime(new Date(data.eventEndTime));
        setLoading(false);
      })
      .catch(e => {
        setError(e.message);
        setLoading(false);
      });
    // 1秒ごとに現在時刻を更新
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const handleEnterRoom = () => {
    window.open('/event-room', '_self');
  };

  // entryTime未取得・エラー時の表示
  if (loading) {
    return <Box sx={{ pt: { xs: 7, sm: 8 }, textAlign: 'center' }}>設定を読み込み中...</Box>;
  }
  if (error || !entryTime || !endTime || !eventEndTime) {
    return <Box sx={{ pt: { xs: 7, sm: 8 }, textAlign: 'center', color: 'error.main' }}>設定エラー: {error}</Box>;
  }

  const canEnter = now >= entryTime && now < eventEndTime;
  const isEventEnded = now >= eventEndTime;

  return (
    <Box sx={{ pt: { xs: 7, sm: 8 }, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', minHeight: '80vh' }}>
      <Paper elevation={6} sx={{ p: 4, borderRadius: 4, maxWidth: 420, width: '100%', textAlign: 'center', background: 'rgba(255,255,255,0.95)', mx: 'auto' }}>
        <Stack spacing={3} alignItems="center">
          <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
            <WhatshotIcon sx={{ color: '#ff7043', fontSize: 40, mr: 1 }} />
            <Typography variant="h4" fontWeight="bold" color="#ff7043">
              もんクエ
            </Typography>
            <WhatshotIcon sx={{ color: '#ff7043', fontSize: 40, ml: 1 }} />
          </Box>
          <Typography variant="subtitle1" color="text.secondary">
            仙台に現れるもんを探せ！<br />
            <p>
              第二回は、もマイルを使った情報戦📱<br />
              ヒントと参加者のコメントを頼りに場所を特定して駆けつけよう！<br />
            </p>
          </Typography>
          <Button
            variant="contained"
            color="warning"
            size="large"
            startIcon={<MeetingRoomIcon />}
            sx={{ borderRadius: 3, fontWeight: 'bold', fontSize: 18, px: 4, py: 1.5, boxShadow: 2 }}
            onClick={handleEnterRoom}
            disabled={!canEnter}
          >
            イベントページへ参加
          </Button>
          {!canEnter && !isEventEnded && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              入室可能時刻：{entryTime.toLocaleString()}<br />
              イベント開始までお待ちください！
            </Typography>
          )}
          {isEventEnded && (
            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
              イベント終了時刻：{eventEndTime.toLocaleString()}<br />
              イベントは終了しました。ご参加ありがとうございました！
            </Typography>
          )}
          <Box mt={2}>
            <Typography variant="body2" color="text.secondary" align="left">
              <b>もんからのお願い！</b><br />
              ・イベント参加中は、もんのグッズを身につけて探してくれると嬉しいな！<br />
              ・チャット機能は、楽しく使いましょう！誹謗中傷、否定だけのコメントはダメ絶対！！<br />
              ・チャットするともんれっじに登録された名前で他の人にも共有されるよ！本名の人は事前に変えて、もんに分かる名前にしてね！<br />
              ・見つけた人は、一緒に記念写真撮ろうね！びっくりしないように優しく声をかけてね笑<br />
              ・仙台に来れない人も、コメントはできるから、ぜひ参加してね！<br />
            </Typography>
          </Box>
          
          {/* Push通知設定 */}
          <PushNotificationSettings />
        </Stack>
      </Paper>
    </Box>
  );
};

export default Event;
